/**
 * Aduce bara de sortare pe rândul chip-urilor de categorie.
 *
 * Horizon o randează pe un rând propriu, pe toată lățimea, care rămâne aproape
 * gol. Designul o are la dreapta, în linie cu filtrele. Mutăm întregul element
 * `.facets--horizontal` — nu doar butonul — ca formularul și comportamentul de
 * sortare să rămână neatinse.
 *
 * Secțiunea de colecție se re-randează la fiecare filtrare, deci refacem
 * mutarea de fiecare dată când reapare în locul original.
 */
const BAR = '.facets--horizontal';
const CHIPS = '.dxd-chips';
const MOVED = 'dxd-sort-inline';
const DESKTOP = '(min-width: 990px)';

function place() {
  const bar = document.querySelector(BAR);
  const chips = document.querySelector(CHIPS);
  if (!bar || !chips) return;

  const wide = window.matchMedia(DESKTOP).matches;
  if (!wide) {
    // Pe mobil lăsăm bara unde o pune tema.
    if (bar.classList.contains(MOVED)) {
      bar.classList.remove(MOVED);
      document.querySelector('.collection-wrapper')?.prepend(bar);
    }
    return;
  }

  // O punem ÎN rândul de chip-uri, nu după el: containerul secțiunii e pe
  // coloană și conține și firimiturile și titlul, deci nu-l putem trece pe rând.
  if (bar.parentElement === chips && bar === chips.lastElementChild) return;

  bar.classList.add(MOVED);
  chips.appendChild(bar);
}

place();
document.addEventListener('DOMContentLoaded', place);
window.addEventListener('resize', place);

// Filtrarea reconstruiește secțiunea; bara revine în locul original.
new MutationObserver(place).observe(document.documentElement, { childList: true, subtree: true });
